import React, { useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";

export default function GeneralEmojiPicker(props) {
  const { onEmojiClick, setShowEmojiPicker } = props;
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowEmojiPicker]);

  return (
    <div className="general-emoji-picker" ref={emojiPickerRef}>
      <EmojiPicker
        searchDisabled={true}
        skinTonesDisabled={true}
        suggestedEmojisMode={""}
        previewConfig={{ showPreview: false }}
        onEmojiClick={onEmojiClick}
      />
    </div>
  );
}
